import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useChartColors } from './ChartTheme';

interface RevenueDistributionChartProps {
  data: Array<{
    range: string;
    count: number;
    percentage: number;
  }>;
}

export function RevenueDistributionChart({ data }: RevenueDistributionChartProps) {
  const colors = useChartColors();

  const chartData = data.map((item) => ({
    name: item.range,
    value: item.count,
    percentage: item.percentage,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Revenue Distribution</CardTitle>
        <CardDescription>Companies by revenue range</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }: any) => `${name}: ${percentage.toFixed(1)}%`} // eslint-disable-line @typescript-eslint/no-explicit-any
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData.map((_entry, index) => (
                <Cell key={`cell-${index}`} fill={colors.chartColors[index % colors.chartColors.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: any) => `${value} companies`} // eslint-disable-line @typescript-eslint/no-explicit-any
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '6px',
                color: 'hsl(var(--foreground))',
              }}
            />
            <Legend
              wrapperStyle={{ color: 'hsl(var(--foreground))' }}
              formatter={(value) => <span style={{ color: 'hsl(var(--foreground))' }}>{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
